import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=3b87e192&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Modal.vue?vue&type=style&index=0&id=3b87e192&prod&lang=stylus&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b87e192",
  null
  ,true
)

export default component.exports